import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom"; 
import {
  Typography, Checkbox, Box
} from '@mui/material';

import {
  calculateRisk
} from '../../common/functions';

const FpzTable = ({ selected = 0, isReport = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    selectedTreatmentWells
  } = useSelector(state => state.fpzReducer);
  //console.log('FpzTable selectedTreatmentWells', selectedTreatmentWells, selected, selectedTreatmentWells[selected]);

  const handleVerifyAllOffsetWells = (verified, selectedTreatmentIndex) => {
    const updatedOffsetWells = selectedTreatmentWells[selectedTreatmentIndex]?.offsetWells?.map(offsetWell => ({
      ...offsetWell,
      verified: verified
    }));
    dispatch({
      type: 'SET_OFFSET_WELLS',
      payload: {
        well: selectedTreatmentWells[selectedTreatmentIndex],
        offsetWells: updatedOffsetWells
      }
    });
  };

  const handleVerifyOffsetWell = (offsetWell, idx, verified, selectedTreatmentIndex) => {
    dispatch({
      type: 'UPDATE_OFFSET_WELL',
      payload: {
        well: selectedTreatmentWells[selectedTreatmentIndex],
        offsetWell: { ...offsetWell, verified: verified },
        index: idx,
      }
    });
  };

  const renderTreatmentTable = (treatmentWell, selectedIndex) => (
    <Box key={treatmentWell.unique_identifier || selectedIndex} mb={4}>
      <div>
        <strong> 
          {treatmentWell.unique_identifier || `Well ${selectedIndex + 1}`}
        </strong>
      </div>
      <div><strong>Operator:</strong> {treatmentWell?.operator}</div>
      <div><strong>Well Name:</strong> {treatmentWell?.surface_location || ''}{`${treatmentWell.lease_name || ''} ${treatmentWell.well_name || ''} ${treatmentWell.well_number || ''}`}</div>
      <div><strong>TVD:</strong> {treatmentWell?.tvd}</div>
      <table border="1" cellPadding="6" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th>#</th>
            <th>Operator</th>
            <th>UWI</th>
            <th>TVD</th>
            <th>Zone</th>
            <th>Status</th>
            <th>Risk</th>
            {!isReport && (
              <th title="Verify As Affected Offset Well">
                Verify
                <Checkbox
                  checked={treatmentWell?.offsetWells?.every(well => well?.verified)}
                  onChange={(e) => handleVerifyAllOffsetWells(e.target.checked, selectedIndex)}
                  title="Verify All Offset Wells"
                />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {treatmentWell?.offsetWells?.filter(well => !isReport || well?.verified)?.map((well, idx) => {
            const isTreatment = (well?.unique_identifier === treatmentWell?.unique_identifier);
            const risk = calculateRisk({
              distanceM: well?.distance,
              verticalDiffM: (treatmentWell?.tvd || 0) - (well?.tvd || 0),
              statusText: well?.status
            });
            return (
              <tr key={idx} style={{ backgroundColor: isTreatment ? 'lightblue' : risk.color }}>
                <td>{idx + 1}</td>
                <td>{well?.operator}</td>
                <td>{well?.unique_identifier}</td>
                <td>{well?.tvd}</td>
                <td>{''}</td>
                <td>{well?.status}</td>
                <td>{isTreatment ? 'Treatment Well'
                  : risk.risk }
                </td>
                {!isReport && (
                  <td>
                    {!isTreatment && (
                      <Checkbox
                        checked={well?.verified || false}
                        onChange={(e) => handleVerifyOffsetWell(well, idx, e.target.checked, selectedIndex)}
                      />
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
  

  return (
    <Box>
      {typeof selected === 'number'
        ? renderTreatmentTable(selectedTreatmentWells[selected], selected)
        : selectedTreatmentWells.map((treatmentWell, index) => (
          <>
            {renderTreatmentTable(treatmentWell, index)}
          </>
          ))}
    </Box>
  );
};

export default FpzTable;
